var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-grid-category-picker"})
}
var staticRenderFns = []

export { render, staticRenderFns }